var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M6.602.66L7.998 0 15 3.314v9.372L7.998 16l-1.396-.66V.66zm-1.222.578L4.3 1.75v12.502l1.08.51V1.239zM2.476 2.612l.863-.406v11.588l-.863-.406V2.612zM1.7 2.98v10.04l-.7-.332V3.312l.7-.33z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZmlsbD0iIzQ0NCIgZD0iTTYuNjAyLjY2IDcuOTk4IDAgMTUgMy4zMTR2OS4zNzJMNy45OTggMTZsLTEuMzk2LS42NlYuNjZ6bS0xLjIyMi41NzhMNC4zIDEuNzV2MTIuNTAybDEuMDguNTFWMS4yMzl6TTIuNDc2IDIuNjEybC44NjMtLjQwNnYxMS41ODhsLS44NjMtLjQwNlYyLjYxMnpNMS43IDIuOTh2MTAuMDRsLS43LS4zMzJWMy4zMTJsLjctLjMzeiIvPgo8L3N2Zz4K";
export { SvgBlog as ReactComponent };